import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ssoToken } from "./api";
import DemoBooking from "./DemoBooking";

// /book-demo?t=<private link token> (from the email). Older requests that have an account can also open it signed in.
export default function BookDemo() {
  const [params] = useSearchParams();
  const token = params.get("t");
  const [auth, setAuth] = useState(null);
  const [checked, setChecked] = useState(!!token);
  useEffect(() => { if (!token) ssoToken().then(setAuth).catch(() => {}).finally(() => setChecked(true)); }, [token]);

  return (
    <div className="min-h-screen geo-bg grid place-items-center p-4">
      <div className="w-full max-w-xl rounded-2xl border border-sand-300 bg-white p-6 sm:p-8 shadow-sm" data-testid="book-demo-page">
        <h1 className="font-display font-semibold text-2xl text-forest-700">Book your school demo</h1>
        <div className="mt-5">
          {!checked ? <div className="text-forest-700">Loading…</div>
            : token || auth ? <DemoBooking token={token} auth={auth} />
            : <div className="text-sm" data-testid="book-signin">This page needs the private link from your email. If you can't find it, reply to the email we sent you and we'll arrange a time.</div>}
        </div>
        {auth && <div className="mt-6 text-sm"><Link className="text-forest-700 underline" to="/dashboard">Go to your dashboard</Link></div>}
      </div>
    </div>
  );
}
